import { useCallback, useState } from 'react';

import { getLabelMessage } from '@gef-ui/localization/messages';
import { useLocalConfirmDialog } from '@gef-ui/material/components/Dialog/ConfirmDialog';

export const useConfirmBeforeLeaveNavigation = ({ condition, otherConfirmDialogProps = {}, onOk, onCancel }) => {
	const [redirectValues, setRedirectValues] = useState(null);

	const [confirmLeaveBeforeSaving, openConfirmLeaveBeforeSaving] = useLocalConfirmDialog({
		backdropClose: false,
		title: getLabelMessage('confirm:doYouWantToLeave'),
		content: getLabelMessage('settings:marketPlaceAgencies.confirmChangeFilterOption'),
		onOk: () => {
			onOk(redirectValues);
			setRedirectValues(null);
		},
		onCancel: () => {
			if (onCancel) {
				onCancel();
			}
			setRedirectValues(null);
		},
		...otherConfirmDialogProps,
	});

	const openIfConditionMet = useCallback(
		(values) => {
			if (condition) {
				setRedirectValues(values);
				openConfirmLeaveBeforeSaving();
			} else {
				onOk(values);
			}
		},
		[condition, openConfirmLeaveBeforeSaving, onOk, setRedirectValues],
	);

	return [confirmLeaveBeforeSaving, openIfConditionMet];
};
